module.exports = __webpack_public_path__ + "img/MD_425x250px-mobile.3cf0999.webp";